export default __webpack_public_path__ + "static/media/leg-left-back.443ff0dd.png";